import styles from "./Heading.module.css";
import { HTMLAttributes, ReactNode } from "react";

export const Heading = ({
  level,
  className = "",
  children,
}: {
  level: number;
  children: ReactNode;
} & HTMLAttributes<HTMLHeadingElement>) => {
  if (level == 1) {
    return (
      <h1 className={`${styles.h1} ${className}`}>{children}</h1>
    );
  }
  if (level == 2) {
    return (
      <h2 className={`${styles.h2} ${className}`}>{children}</h2>
    );
  }
  if (level == 3) {
    return (
      <h2 className={`${styles.h3} ${className}`}>{children}</h2>
    );
  }
  if (level == 5) {
    return (
      <h5 className={`${styles.h5} ${className}`}>{children}</h5>
    );
  }
  return null;
};
